import axios from './axios';

export default {
  get: async id => {
    const res = await axios.get(`/qrcodes/${id}`);
    return res;
  },

  update: async (id, body) => {
    const { data } = await axios.put(`/qrcodes/${id}`, body);
    return data;
  },

  create: async query => {
    const params = { params: query };
    const { data } = await axios.post(`/qrcodes`, '', params);
    return data;
  },

  getImage: async id => {
    const { data } = await axios.get(`/qrcodes/show/${id}`, {
      responseType: 'arraybuffer'
    });
    return data;
  }
};
